<ng-progress #progressBar aria-label="Loading bar"></ng-progress>

<router-outlet></router-outlet>

<app-toasts-service-component></app-toasts-service-component>
